<template>
  <div class="withdrawal-history-box">
    <div class="wh-header-spacer" aria-hidden="true"></div>
    <div class="wh-header-fixed">
      <div class="wh-header-inner">
        <img
          class="wh-back"
          src="../../assets/withdrawal_v2/back.png"
          alt=""
          @click="goBack"
        />
        <p class="wh-title">{{ $t("guild_withdrawal_records") }}</p>
        <img
          class="wh-service"
          src="../../assets/withdrawal_v2/service.png"
          alt=""
          @click="goPublish"
        />
      </div>
    </div>

    <div class="wh-filter-bar hide-scrollbar" ref="filterBar">
      <button
        v-for="tab in filterTabs"
        :key="tab.value"
        type="button"
        class="wh-filter-item"
        :class="{ active: activeFilter === tab.value }"
        @click="changeFilter(tab.value)"
      >
        {{ $t(tab.labelKey) }}
      </button>
    </div>

    <div class="list-summary" v-if="!loading">
      <span>{{ $t("guild_apply_time") }}</span>
      <span>{{ $t("guild_withdraw_record_total", { s: total }) }}</span>
    </div>

    <van-pull-refresh
      v-model="refreshing"
      class="list-scroll-container hide-scrollbar"
      @refresh="onRefresh"
    >
      <van-list
        v-model="loadingMore"
        :finished="noMore"
        :finished-text="list.length === 0 ? '' : $t('guild_no_more_data')"
        :immediate-check="false"
        @load="onLoad"
      >
        <div class="list-item" v-for="(item, index) in list" :key="item.id || index">
          <div class="item-head">
            <p class="amount">{{ formatAmount(item.coinNum) }}</p>
            <!-- 状态标签样式：按提现方式(withdrawType)区分状态集合；提现中=status1橙 / 已完成=status2蓝 / 已拒绝=status3红 -->
            <span
              class="status-badge"
              :class="{
                status1: isWithdrawingStatus(item.status, item.withdrawType),
                status2: isCompletedStatus(item.status),
                status3: isRejectedStatus(item.status, item.withdrawType),
              }"
            >
              {{ item.statusLabel || getStatusText(item.status, item.withdrawType) }}
            </span>
          </div>
          <div class="item-rows">
            <div class="item-row">
              <span class="row-label">{{ $t("guild_submit_application") }}</span>
              <span class="row-value">{{ getWithdrawTypeText(item.withdrawType) }}</span>
            </div>
            <div class="item-row">
              <span class="row-label">{{ $t("guild_order_id") }}</span>
              <span class="row-value">{{ item.orderId || item.withdrawId || item.id || "--" }}</span>
            </div>
            <!-- 隐藏手续费 -->
            <!-- 手续费：仅自提现(withdrawType=1)展示，展示逻辑与确认页一致（feeFixed/100 + feeRate%） -->
            <!-- <div v-if="item.withdrawType === 1 && hasChannelFee(item)" class="item-row">
              <span class="row-label">
                {{ $t("guild_reference_fee") }}
                <span v-if="item.feeFixed != null && item.feeFixed !== 0">
                  ({{ item.cc || item.currency }} {{ (Number(item.feeFixed) / 100).toFixed(2) }}
                </span>
                <span v-if="(item.feeRate != null && item.feeRate !== 0) && (item.feeFixed != null && item.feeFixed !== 0)">+</span>
                <span v-if="item.feeRate != null && item.feeRate !== 0">
                  {{ item.feeRate }}%)
                </span>
              </span>
              <span v-if="calcFeeAmount(item) !== ''" class="row-value">
                {{ item.cc || item.feeCurrency }} {{ calcFeeAmount(item).toFixed(2) }}
              </span>
            </div> -->
            <div class="item-row">
              <span class="row-label">{{ $t("guild_confirm_submit_application") }}</span>
              <span class="row-value">{{ formatDate(item.createTime) }}</span>
            </div>
            <div class="item-row" v-if="showProcessTime(item.status, item.withdrawType)">
              <span class="row-label">{{ $t("guild_freeze_notice") }}</span>
              <span class="row-value">{{ formatDate(item.updateTime) }}</span>
            </div>
          </div>
          <div
            v-if="item.reason && isRejectedStatus(item.status, item.withdrawType)"
            class="refuse-box"
          >
            <div class="refuse-header">{{ $t("guild_communicate_with_leader") }}</div>
            <div class="refuse-content">{{ item.reason }}</div>
          </div>
        </div>
      </van-list>
      <div v-if="!loading && !refreshing && list.length === 0" class="no-data-box">
        <p></p>
      </div>
    </van-pull-refresh>

    <div class="loading-box" v-if="loading">
      <van-loading type="spinner" vertical />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VanList from "vant/lib/list";
import VanPullRefresh from "vant/lib/pull-refresh";
import VanLoading from "vant/lib/loading";
import "vant/lib/list/style";
import "vant/lib/pull-refresh/style";
import "vant/lib/loading/style";

export default {
  name: "withdrawalHistory",
  components: {
    VanList,
    VanPullRefresh,
    VanLoading,
  },
  // 提现记录列表、分页状态与筛选 Tab 配置
  data() {
    return {
      list: [],
      page: 1,
      pageSize: 5,
      total: 0,
      loading: false,
      loadingMore: false,
      refreshing: false,
      noMore: false,
      guildId: "",
      appealToPlatformUrl: "",
      activeFilter: "all",
      // 状态筛选顺序：全部（默认）/ 提现中 / 已完成 / 已拒绝
      filterTabs: [
        { value: "all", labelKey: "guild_all" },
        { value: "withdrawing", labelKey: "guild_with_ing" },
        { value: "completed", labelKey: "guild_withdrawal_method" },
        { value: "rejected", labelKey: "guild_leader_withdraw" },
      ],
    };
  },
  // 初始化：从路由读取公会 id / 公会长 uid / 申诉平台链接，并按路由筛选参数设置默认 Tab
  created() {
    // 从路由读取公会 id / 公会长 uid / 申诉平台链接
    this.guildId = this.$route.query.guildId;
    this.guildUid = this.$route.query.guildUid;
    this.appealToPlatformUrl = this.$route.query.toUrl || "";
    // 若路由带 filter 参数且在合法 Tab 值内，则作为默认筛选（如首页"提现中"跳转）
    const filter = this.$route.query.filter;
    if (filter && this.filterTabs.some((t) => t.value === filter)) {
      this.activeFilter = filter;
    }
  },
  // 挂载后初始化登录态并加载第一页记录
  mounted() {
    // 初始化登录态并加载第一页记录
    this.getUserInfo();
    this.onLoad();
  },
  methods: {
    // 返回：无上一页时关闭 webview，否则路由返回
    goBack() {
      if (window.history.length <= 1) {
        this.$completes.complete("getPreviousPage");
      } else {
        this.$router.go(-1);
      }
    },
    // 获取当前 App 版本号（仅从 UA 中解析），不在 App 内则返回 null
    getAppVersion() {
      const ua = navigator.userAgent;
      const match = ua.match(/app\/[^:\s]+:(\d+(?:\.\d+)+)/);
      return match ? match[1] : null;
    },
    // 打开平台申诉链接（携带语言与用户 id 参数）
    goPublish() {
      const url =
        this.appealToPlatformUrl +
        "?isShowNav=0&langType=" +
        this.lang +
        "&userId=" +
        this.uid +
        "&type=4";
      // 站外：当前页面替换地址并计入浏览器历史记录；App 内：新开窗口
      if (this.getAppVersion()) {
        window.open(url);
      } else {
        window.location.href = url;
      }
    },
    // 切换筛选 Tab：重置列表并重新加载，并将选中 Tab 滚动到可视区域内
    changeFilter(value) {
      if (this.activeFilter === value) return;
      this.activeFilter = value;
      this.$nextTick(() => {
        const bar = this.$refs.filterBar;
        if (!bar) return;
        const active = bar.querySelector(".wh-filter-item.active");
        if (active) active.scrollIntoView({ inline: "center", block: "nearest" });
      });
      this.resetList();
      this.onLoad();
    },
    // 下拉刷新：重置分页并强制拉取第一页（保留 total，避免请求期间"共几笔"变成 0；不再触发 van-list 底部加载）
    onRefresh() {
      this.resetList(true);
      this.fetchList({ isRefresh: true }).finally(() => {
        this.refreshing = false;
        this.loadingMore = false;
      });
    },
    // 重置分页与列表状态；keepTotal 为 true 时不清空 total（下拉刷新保留原有"共几笔"）
    resetList(keepTotal = false) {
      this.page = 1;
      this.list = [];
      if (!keepTotal) this.total = 0;
      this.noMore = false;
      this.loadingMore = false;
    },
    // 筛选 Tab 映射为接口 filterType：全部0/提现中1/已完成2/已拒绝3
    getFilterType() {
      const map = {
        all: 0,
        withdrawing: 1,
        completed: 2,
        rejected: 3,
      };
      return map[this.activeFilter] || 0;
    },
    // 是否"提现中"：按提现方式区分状态集合（withdrawType 2/3 转公会长/转reseller；1/5 自提现/平台结算）
    isWithdrawingStatus(status, withdrawType) {
      const wt = Number(withdrawType);
      // 转公会长/转reseller：提现中为 0, 4
      if (wt === 2 || wt === 3) {
        return status === 0 || status === 4;
      }
      // 自提现/平台结算：提现中为 0, 7, 8
      return status === 0 || status === 7 || status === 8;
    },
    // 是否已完成（status=1）
    isCompletedStatus(status) {
      return status === 1;
    },
    // 是否已拒绝：按提现方式区分状态集合（withdrawType 2/3：2,3,5；1/5：2,3,4,5,6）
    isRejectedStatus(status, withdrawType) {
      const wt = Number(withdrawType);
      // 转公会长/转reseller：已拒绝为 2, 3, 5
      if (wt === 2 || wt === 3) {
        return status === 2 || status === 3 || status === 5;
      }
      // 自提现/平台结算：已拒绝为 2, 3, 4, 5, 6
      return status === 2 || status === 3 || status === 4 || status === 5 || status === 6;
    },
    // 是否需要展示处理时间（已完成/已拒绝）
    showProcessTime(status, withdrawType) {
      return this.isCompletedStatus(status) || this.isRejectedStatus(status, withdrawType);
    },
    // 从本地缓存初始化鉴权信息并设置语言
    getUserInfo() {
      // 提取 UA 中的设备类型用于 deviceId 兜底
      var ids = navigator.userAgent.match(
        /(iPhone|iPod|iPad|Android|BlackBerry|Windows Phone)/
      );
      if (ids) {
        ids = ids[0];
      } else {
        ids = "Unknown Device";
      }
      const raw = localStorage.getItem("data");
      let data = JSON.parse(raw);
      this.token = data.token;
      this.uid = data.uid || data.userId;
      this.lang = data.lang || navigator.language;
      this.deviceId = data.deviceId || ids;
      // 按语言映射设置 i18n locale
      let langs = this.lang.substring(0, 2);
      if (langs == "zh") {
        if (this.lang == "zh-TW" || this.lang == "zh-HK") {
          this.$i18n.locale = "tc";
        } else {
          this.$i18n.locale = "zh";
        }
      } else if (langs == "en") {
        this.$i18n.locale = "en";
      } else if (langs == "ar") {
        this.$i18n.locale = "ar";
      } else if (langs == "tr") {
        this.$i18n.locale = "tr";
      } else if (langs == "es") {
        this.$i18n.locale = "es";
      } else if (langs == "pt") {
        this.$i18n.locale = "pt";
      } else if (langs == "fr") {
        this.$i18n.locale = "fr";
      } else if (langs == "id") {
        this.$i18n.locale = "id";
      } else if (langs == "ms") {
        this.$i18n.locale = "ms";
      } else {
        this.$i18n.locale = "en";
      }
      document.title = this.$t("guild_withdrawal_records");
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
    },
    // 金额千分位格式化（字符串正则方式）
    formatAmount(amount) {
      if (!amount) return "0";
      return String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // 时间戳格式化为 YYYY/MM/DD HH:mm
    formatDate(timestamp) {
      if (!timestamp) return "--";
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}/${month}/${day} ${hours}:${minutes}`;
    },
    // 订单状态文案映射（0待确认/1完成/2会长拒绝/3超时拒绝/4平台审核/5平台拒绝/6Reseller审核/7安全审核）
    getStatusText(status, type) {
      if (status === 0 || status === -1) {
        // 待确认：转会长场景显示"公会审核中"，其余显示"待确认"
        return type != 2
          ? this.$t("guild_confirm")
          : this.$t("guild_status_guild_review");
      }
      if (status === 1) return this.$t("guild_withdrawal_method");
      if (status === 2) return this.$t("guild_leader_withdraw");
      if (status === 3) return this.$t("guild_status_timeout_rejected_2");
      if (status === 4) return this.$t("guild_status_platform_review");
      if (status === 5) return this.$t("guild_status_platform_rejected");
      if (status === 6) return this.$t("guild_status_reseller_review");
      if (status === 7) return this.$t("guild_status_security_review");
      return this.$t("guild_status_unknown");
    },
    // 提现类型文案映射（1自提现/2转会长/3发薪给reseller/4转钻石/5平台结算/6RESELLER）
    getWithdrawTypeText(type) {
      const typeMap = {
        1: this.$t("guild_self_withdraw"),
        2: this.$t("guild_transfer_to_leader"),
        3: this.$t("guild_salary_to_reseller"),
        4: this.$t("guild_convert_to_diamond"),
        5: this.$t("guild_platform_settlement"),
        6: "RESELLER",
      };
      return typeMap[type] || this.$t("guild_status_unknown");
    },
    // 是否有手续费：feeRate 或 feeFixed 存在且非 0（与确认页一致，否则不展示手续费行）
    hasChannelFee(item) {
      return (
        (item.feeRate != null && Number(item.feeRate) !== 0) ||
        (item.feeFixed != null && Number(item.feeFixed) !== 0)
      );
    },
    // 手续费金额：(提现金额(coinNum) × feeRate + feeFixed) / 100；保留两位小数；与确认页计算一致
    calcFeeAmount(item) {
      if (!item || !this.hasChannelFee(item)) return "";
      const amount = Number(item.coinNum) || 0;
      const rate = Number(item.feeRate) || 0;
      const fixed = Number(item.feeFixed) || 0;
      const raw = (amount * rate + fixed) / 100;
      // 保留两位小数：第三位存在时第二位进一（四舍五入到分，加极小值避免浮点误差）
      return Math.round((raw + Number.EPSILON) * 100) / 100;
    },
    // 上拉加载更多（van-list 触发）：刷新/已无更多/正在加载时跳过，避免重复请求导致 page 错乱
    onLoad() {
      if (this.refreshing) {
        this.loadingMore = false;
        return;
      }
      if (this.noMore) {
        this.loadingMore = false;
        return;
      }
      // 仅全屏 loading 时跳过（防止切换 Tab 重复请求 page=1）；不能用 loadingMore，因 van-list 触发 @load 时已置 true
      if (this.loading) return;
      this.fetchList({ isRefresh: false });
    },
    // 拉取提现记录：首页显示全屏 loading，翻页追加列表
    fetchList({ isRefresh = false } = {}) {
      // 首页请求显示全屏 loading，翻页请求显示底部 loading
      if (this.page === 1 && !isRefresh) {
        this.loading = true;
      } else if (!isRefresh) {
        this.loadingMore = true;
      }

      // 状态筛选映射为接口 status：0全部/1提现中/2已完成/3已拒绝
      const status = this.getFilterType();
      return axios
        .get(
          this.$serviceIp +
            `api/trade/guild/withdraw/record?page=${this.page}&pageSize=${this.pageSize}&status=${status}&token=${this.token}&uid=${this.uid}`,
          {
            headers: {
              version: "3.0",
              deviceId: this.deviceId,
              lang: this.lang,
            },
          }
        )
        .then(({ data }) => {
          if (data.code === 200) {
            const payload = data.data || {};
            const newData = payload.list || [];
            // 首页替换列表并记录总数，翻页追加
            if (this.page === 1) {
              this.list = newData;
              this.total = payload.total != null ? payload.total : newData.length;
            } else {
              this.list.push(...newData);
            }
            // 返回条数不足一页即视为没有更多
            if (newData.length < this.pageSize) {
              this.noMore = true;
            } else {
              this.page += 1;
            }
          } else {
            this.$message?.error(data.msg || "加载失败");
          }
        })
        .catch((err) => {
          this.$message?.error(err.message || "网络错误");
        })
        .finally(() => {
          this.loading = false;
          this.loadingMore = false;
        });
    },
  },
};
</script>

<style scoped>
body {
  background-color: #f5f6f8;
  font-family: "Mada";
}

.withdrawal-history-box {
  background-color: #f5f6f8;
  min-height: 100vh;
  font-family:'Montserrat';
}

.wh-header-spacer {
  height: calc(88px + env(safe-area-inset-top));
  height: calc(88px + constant(safe-area-inset-top));
}

.wh-header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding-top: env(safe-area-inset-top);
  padding-top: constant(safe-area-inset-top);
  background: #f5f6f8;
}

.wh-header-inner {
  position: relative;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 28px;
}

.wh-back {
  position: absolute;
  left: 28px;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
}

.wh-title {
  margin: 0;
  font-size: 26px;
  font-weight: 600;
  color: #121212;
}

.wh-service {
  position: absolute;
  right: 28px;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
}

.wh-filter-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 28px 20px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  flex-wrap: nowrap;
}

.wh-filter-item {
  height: 64px;
  border: none;
  border-radius: 32px;
  background: transparent;
  font-size: 24px;
  font-weight: 500;
  color: #AFA9B4;
  padding: 16px 24px;
  box-sizing: border-box;
  white-space: nowrap;
  flex-shrink: 0;
}

.wh-filter-item.active {
  background: #fff;
  color: #000;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.list-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px 20px;
  font-size: 24px;
  font-weight: 400;
  color: #AFA9B4;
}

.list-scroll-container {
  display: block;
  padding: 0 25px 32px;
  height: calc(100vh - 240px - env(safe-area-inset-top));
  height: calc(100vh - 240px - constant(safe-area-inset-top));
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
}

.list-item {
  padding: 24px;
  border-radius: 24px;
  box-sizing: border-box;
  background-color: #fff;
  margin-bottom: 20px;
  position: relative;
}

.item-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #EEEEEE;

}

.list-item .amount {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 32px;
  font-weight: 700;
  color: #262427;
  margin: 0;
}

.amount::before {
  content: "";
  width: 32px;
  height: 32px;
  background: url("../../assets/h5/icon$.png") no-repeat;
  background-size: 100% 100%;
  margin-right: 4px;
}

.status-badge {
  flex-shrink: 0;
  font-size: 20px;
  font-weight: 400;
  height: 48px;
  line-height: 48px;
  text-align: center;
  padding: 0 20px;
  border-radius: 0 20px 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* position: absolute;
  right: 0;
  left: 0; */
  margin-top: -24px;
  margin-right: -24px;
}

.status-badge::before {
  content: "";
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.status1 {
  color: #e78300;
  background-color: #ffe6d2;
}
.status1::before {
  background: url("../../assets/h5/status1.png") no-repeat;
  background-size: 100% 100%;
}
.status2 {
  color: #0060e7;
  background-color: #d2ebff;
}
.status2::before {
  background: url("../../assets/h5/status2.png") no-repeat;
  background-size: 100% 100%;
}
.status3 {
  color: #e54444;
  background-color: #ffe2e2;
}
.status3::before {
  background: url("../../assets/h5/status3.png") no-repeat;
  background-size: 100% 100%;
}
.status4 {
  color: #89848d;
  background-color: #e9e9e9;
}
.status4::before {
  background: url("../../assets/h5/status4.png") no-repeat;
  background-size: 100% 100%;
}

.item-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.item-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 8px;
}

.row-label {
  flex-shrink: 0;
  color: #89848d;
}

.row-value {
  text-align: right;
  color: #000;
  word-break: break-all;
}

/* 手续费左侧固定值括号（cc feeFixed）弱化显示 */
.row-fee-fixed {
  font-weight: 400;
  font-size: 12px;
  color: #8a8a8f;
}

.refuse-box {
  min-height: 60px;
  border-radius: 16px;
  background-color: #fff4f4;
  padding: 20px 24px;
  margin-top: 16px;
}

.refuse-header {
  font-size: 24px;
  font-weight: 500;
  line-height: 30px;
  color: #ff4365;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.refuse-header::before {
  content: "";
  width: 30px;
  height: 30px;
  background: url("../../assets/h5/elert.png") no-repeat;
  background-size: 100% 100%;
  margin-right: 5px;
}

.refuse-content {
  font-size: 22px;
  font-weight: 500;
  line-height: 30px;
  color: #262427;
  padding-left: 36px;
}

.loading-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 101;
}

.no-data-box {
  width: 100%;
  min-height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.no-data-box p {
  width: 240px;
  height: 240px;
  background: url("../../assets/withdrawal/null.png") no-repeat;
  background-size: 100% 100%;
}

.hide-scrollbar {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

html[lang="ar"] .withdrawal-history-box {
  direction: rtl;
}

html[lang="ar"] .wh-back {
  left: auto;
  right: 28px;
  transform: translateY(-50%) rotateY(180deg);
}

html[lang="ar"] .wh-service {
  right: auto;
  left: 28px;
}

html[lang="ar"] .amount::before {
  margin-right: 0;
  margin-left: 4px;
}

html[lang="ar"] .refuse-header::before {
  margin-right: 0;
  margin-left: 5px;
}

html[lang="ar"] .refuse-content {
  padding-left: 0;
  padding-right: 36px;
}

html[lang="ar"] .row-value {
  text-align: left;
}
html[lang="ar"] .status-badge {
  margin-left: -24px;
  border-radius: 20px 0 20px 0;
}
</style>
